import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";

import { Form, Col, Row, FormControl } from "react-bootstrap";
import { toast } from "react-toastify";

import UserService from "../../services/user.service";

function Modaleditpass(props) {
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});

  const handleClose = () => {
    props.hidden(false);
  };

  //   const [acceptedTerms, setAcceptedTerms] = useState(false);
  useEffect(() => {
    setEditForm(props.userid);
  }, [props.userid]);

  const setEditForm = (userid) => {
    UserService.getUserprofile(userid)
      .then((response) => {
        setForm({
          username: response.data.user.registerUsername,
          Email: response.data.user.registerEmail,
        });
      })
      .catch((error) => {
        toast.error(error);
      });

    setErrors({});
  };

  // const initialForm = () => {
  //   setForm({});
  //   setErrors({});
  // };
  const setField = (field, value) => {
    setForm({
      ...form,
      [field.name]: value,
    });
    if (errors[field.name])
      setErrors({
        ...errors,
        [field.name]: null,
      });
  };
  const findFormErrors = () => {
    const { newPassword, conPassword } = form;
    const newErrors = {};

    // registerPassword errors
    if (!newPassword || newPassword === "")
      newErrors.newPassword = "กรุณากรอก Password";
    else if (newPassword.length < 6)
      newErrors.newPassword = "Password ต้องมากกว่า 6 ตัวอักษร";

    // conPassword errors
    if (!conPassword || conPassword === "")
      newErrors.conPassword = "กรุณากรอกยืนยัน Password";
    else if (conPassword != newPassword)
      newErrors.conPassword = "ยืนยัน Password ไม่ถูกต้อง";

    // // comment errors
    // if (!comment || comment === "") newErrors.comment = "cannot be blank!";
    // else if (comment.length > 100) newErrors.comment = "comment is too long!";

    return newErrors;
  };

  const handleSubmit = (e) => {
    // console.log(form);
    e.preventDefault();
    // get our new errors
    const newErrors = findFormErrors();
    // Conditional logic:
    if (Object.keys(newErrors).length > 0) {
      // We got errors!
      setErrors(newErrors);
    } else {
      // No errors! Put any logic here for the form submission!
      // alert("Thank you for your feedback!");
      // console.log(form);
      UserService.newPass(props.userid, form)
        .then((response) => {
          if (response.data.success) {
            handleClose();
            toast.success(response.data.message);
          } else {
            toast.error(response.data.message);
          }
          // window.location.reload(true);
          // const rows = props.data.push(response.data.user);
          // props.addData(rows);
          // initialForm();
        })
        .catch((error) => {
          // console.error("error fetching data: ", error);
          toast.error(error);
        });
    }
  };

  return (
    <>
      <Modal size="lg" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>แก้ไขพาสเวิร์ด</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>ชื่อผู้ใช้งาน</Form.Label>
                  <FormControl
                    placeholder="Username"
                    name="username"
                    value={form.username || ""}
                    readOnly
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.username}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>อีเมลล์</Form.Label>
                  <FormControl
                    placeholder="E-mail"
                    type="email"
                    name="registerEmail"
                    value={form.Email || ""}
                    readOnly
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.Email}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row className="align-items-center">
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>รหัสผ่าน</Form.Label>
                  <FormControl
                    placeholder="รหัสผ่าน"
                    name="newPassword"
                    type="password"
                    value={form.newPassword || ""}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.newPassword}
                  />{" "}
                  <Form.Control.Feedback type="invalid">
                    {errors.newPassword}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-2">
                  <Form.Label>ยืนยันรหัสผ่าน</Form.Label>
                  <FormControl
                    placeholder="ยืนยันรหัสผ่าน"
                    type="password"
                    name="conPassword"
                    value={form.conPassword || ""}
                    onChange={(e) => setField(e.target, e.target.value)}
                    isInvalid={!!errors.conPassword}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.conPassword}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-warning" onClick={handleClose}>
            ยกเลิก
          </button>
          <button
            className="btn btn-primary"
            type="submit"
            onClick={handleSubmit}
          >
            บันทึก
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Modaleditpass;

Modaleditpass.propTypes = {
  show: PropTypes.bool,
  hidden: PropTypes.func,
  // data: PropTypes.object,
  // setdata: PropTypes.func,
  userid: PropTypes.number,
};
